// @owners { team: patients }
import { type SurveyResponse } from '@alto/scriptdash/alto/surveys/types/v1/survey_response';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { get } from '~shared/helpers/apiHelper';

export const rateShipment = createQueryKeys('rateShipment', {
  pending: {
    queryKey: null,
    queryFn: async (): Promise<SurveyResponse | null> => {
      const response = await get('/survey_responses/check_pending', { survey_type: 'rate_shipment' });
      if (response.error) {
        throw response.error;
      }
      return response?.pending_survey_response ?? null;
    },
    // The global QueryClient defaults 5 min staleTime; fetchQuery honors it and would return a
    // cached survey response without hitting the network. This survey check fires on every
    // SET_PRESENCE / LOGIN_SUCCEEDED, so pin staleTime: 0 to always fetch fresh — matching the old
    // thunk's behavior, so a survey that becomes available within the 5 min window isn't missed.
    staleTime: 0,
    retry: false,
  },
});
